import { exportToExcel } from '../utils/exportExcel';
import { useAuth } from '../hooks/useAuth';
import { useQuery } from '@tanstack/react-query';
import api from '../api';

export default function TableExportButton({
  filename,
  sheetName,
  columns,
  rows,
  reportName,
  label = 'Export to Excel',
  className = ''
}) {
  const { user } = useAuth();
  const { data: branding } = useQuery({
    queryKey: ['poster-branding'],
    queryFn: () => api.get('/settings/poster-branding').then(r => r.data),
    enabled: !!user && user.role !== 'candidate'
  });
  if (user?.role === 'candidate') return null;

  const companyName =
    branding?.appName || user?.companyName || user?.sidebarLabel || user?.displayName || 'Paytiemp';

  return (
    <button
      type="button"
      className={`px-3 py-2 text-sm border border-[hsl(var(--ds-primary))] text-[hsl(var(--ds-primary))] bg-[hsl(var(--ds-surface))] hover:bg-[hsl(var(--ds-primary)/0.08)] disabled:opacity-60 rounded-xl shadow-sm ${className}`.trim()}
      disabled={!rows?.length}
      onClick={() => exportToExcel({ filename, sheetName, columns, rows, companyName, reportName })}
      title={!rows?.length ? 'No data to export' : 'Export current table rows'}
    >
      {label}
    </button>
  );
}

